<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title"><a id="page_5"></a>Contents</h1>
<h2 class="toc"><a href="#/xhtml/03_Foreword">Foreword by Nigel Cave</a></h2>
<h2 class="toc"><a href="#/xhtml/04_Bibliography">Bibliography</a></h2>
<h2 class="toc-para1"><a href="#/xhtml/05_Chapter01"><span class="toc-num"><em class="italic">Chapter One</em></span><span class="bold">Hitler’s First Russian Winter</span></a></h2>
<h2 class="toc-para"><span href="#/xhtml/06_Chapter02" title="Link target outside of Sample"><span class="toc-num"><em class="italic">Chapter Two</em></span><span class="bold">Rommel and The Fall of Tobruk</span></span></h2>
<h2 class="toc-para"><span href="#/xhtml/07_Chapter03" title="Link target outside of Sample"><span class="toc-num"><em class="italic">Chapter Three</em></span><span class="bold">Tojo Attacks Pearl Harbor</span></span></h2>
<h2 class="toc-para"><span href="#/xhtml/08_Chapter04" title="Link target outside of Sample"><span class="toc-num"><em class="italic">Chapter Four</em></span><span class="bold">Jap Onslaught in Southeast Asia</span></span></h2>
<h2 class="toc-para"><span href="#/xhtml/09_Chapter05" title="Link target outside of Sample"><span class="toc-num"><em class="italic">Chapter Five</em></span><span class="bold">Tokyo Attacked –The Doolittle Revenge Raid</span></span></h2>
<h2 class="toc-para"><span href="#/xhtml/10_Chapter06" title="Link target outside of Sample"><span class="toc-num"><em class="italic">Chapter Six</em></span><span class="bold">Battle of The Coral Sea and Battle of Midway</span></span></h2>
<h2 class="toc-para"><span href="#/xhtml/11_Chapter07" title="Link target outside of Sample"><span class="toc-num"><em class="italic">Chapter Seven</em></span><span class="bold">British Target St Nazaire Dry Dock</span></span></h2>
<h2 class="toc-para"><span href="#/xhtml/12_Chapter08" title="Link target outside of Sample"><span class="toc-num"><em class="italic">Chapter Eight</em></span><span class="bold">Operation Biting –The Bruneval Raid</span></span></h2>
<h2 class="toc-para"><span href="#/xhtml/13_Chapter09" title="Link target outside of Sample"><span class="toc-num"><em class="italic">Chapter Nine</em></span><span class="bold">RAF Starts Area Bombing: Target Civilians</span></span></h2>
<h2 class="toc-para"><span href="#/xhtml/14_Chapter10" title="Link target outside of Sample"><span class="toc-num"><em class="italic">Chapter Ten</em></span><span class="bold">Hitler Battles for the Caucasus Oilfields</span></span></h2>
<h2 class="toc-para"><span href="#/xhtml/15_Chapter11" title="Link target outside of Sample"><span class="toc-num"><em class="italic">Chapter Eleven</em></span><span class="bold">The Canadians Land at Dieppe</span></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?0054f240